import { render, staticRenderFns } from "./ContractConnectDocumentTableRow.vue?vue&type=template&id=4980577e&"
import script from "./ContractConnectDocumentTableRow.vue?vue&type=script&lang=js&"
export * from "./ContractConnectDocumentTableRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports